import { useParams } from 'react-router-dom';

export function useRequiredParam(name: string): string {
  const param = useParams()[name];
  if (param == null) {
    throw new Error(`Undefined parameter: ${name}`);
  }
  return param;
}
